var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4,11 L36.8,7.3 L43,7.3 L43,0.6 L0.6,0.6 L0.6,43 L43,43 L43,36.3 L37.1,36.3 L34.9,33.8 L32.7,36.3 L16.1,36.3 L16.1,22.9 L10.6,22.9 L17.5,7.4 L24.2,7.4 L25.8,10.9 L25.8,7.4 L34.1,7.4 L35.4,11 L35.4,11 Z M30.8,13.5 L30.8,12 L31.4,13.5 L34.2,20.9 L36.8,20.9 L39.6,13.5 L40.1,12 L40.1,20.8 L43,20.8 L43,9.5 L38.2,9.5 L36,15.2 L35.4,16.8 L34.8,15.2 L32.6,9.5 L27.8,9.5 L27.8,20.8 L30.8,20.8 L30.8,13.5 L30.8,13.5 Z M24.6,20.8 L27.9,20.8 L22.9,9.5 L19,9.5 L14,20.8 L17.3,20.8 L18.2,18.6 L23.7,18.6 L24.6,20.8 L24.6,20.8 Z M20.4,13.4 L21,12 L21.6,13.4 L22.8,16.3 L19.3,16.3 L20.4,13.4 L20.4,13.4 Z M18.4,22.9 L18.4,34.2 L27.8,34.2 L27.8,31.8 L21.2,31.8 L21.2,29.8 L27.6,29.8 L27.6,27.4 L21.2,27.4 L21.2,25.4 L27.8,25.4 L27.8,23 L18.4,22.9 L18.4,22.9 Z M38.4,34.1 L42.1,34.1 L36.8,28.5 L42.1,22.9 L38.4,22.9 L35,26.6 L31.6,22.9 L27.8,22.9 L33.1,28.6 L27.8,34.2 L31.4,34.2 L34.8,30.5 L38.4,34.1 L38.4,34.1 Z M39.8,28.5 L43,31.8 L43,25.3 L39.8,28.5 L39.8,28.5 Z",
    fill: "#006FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.01057d5973efda80744e7c8162bb41ef.svg";
export { ForwardRef as ReactComponent };